export default __webpack_public_path__ + "static/media/d.065740fa.svg";